module.exports = __webpack_public_path__ + "static/img3_ats-ce9ae100a951231c5f81fd03e6c465dd.png";